import { levelConstants } from './hrConstants/levelConstants'
import { payGradeConstants } from './hrConstants/payGradeConstants'

export const hrConstants = {
	levelConstants,
	payGradeConstants,
}
